var categories = document.querySelectorAll('.faq__main');
var firstCategory = categories[0];
var categoryList = document.querySelector('[faq-categories]');
var categorySelect = document.querySelector('[faq-select]');
firstCategory.classList.remove('hidden');
categories.forEach(function (categorie) {
  // Create the buttons
  var title = categorie.querySelector('.faq__wrapper').dataset.title;
  var listItem = document.createElement("li");
  var listOption = document.createElement("option");
  var button = document.createElement('button');
  button.classList.add('link', 'full-unstyled-link', 'focus-inset');
  button.dataset.expand = title;
  listOption.value = title;
  listItem.appendChild(button);
  listOption.innerText = title;
  button.innerHTML = title;
  categoryList.appendChild(listItem);
  categorySelect.appendChild(listOption);
});
var categoryLinks = document.querySelectorAll('.faq__categories button');
var firstCategoryLink = categoryLinks[0];
firstCategoryLink.classList.add('active');
categoryList.addEventListener('click', function (event) {
  if (event.target.tagName.toLowerCase() === 'button') {
    document.querySelector('.faq__categories button.active').classList.remove('active');
    var currentLink = event.target.dataset.expand;
    event.target.classList.add('active');
    var activeFaq = document.querySelector('.faq__wrapper[data-title="' + currentLink + '"]');
    categories.forEach(function (categorie) {
      categorie.classList.add('hidden');
    });
    activeFaq.parentElement.classList.remove('hidden');
  } else {
    return;
  }
});
categorySelect.addEventListener('change', function (event) {
  var currentLink = event.target.value;
  categories.forEach(function (categorie) {
    categorie.classList.add('hidden');
  });
  var activeFaq = document.querySelector('.faq__wrapper[data-title="' + currentLink + '"]');
  activeFaq.parentElement.classList.remove('hidden');
});
